import React from 'react'

import { AIGeneratedGradientFilled, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

const ICON_SIZE = { width: '16', height: '16' }

// The value is user-specific, so it only arrives with pageConfig: the tag stays hidden at SSR on
// this action-cached fast page. pageConfig sends it for signed-in viewers only, so an absent key
// (signed-out) shows the tag (navigation precedent).
const selectShowFreeTrialTag = (config) => !!config && config.showFreeTrialTag !== false

function FreeTrialTag() {
  const translate = useTranslate()
  const showFreeTrialTag = usePageConfig({ select: selectShowFreeTrialTag })

  if (!showFreeTrialTag) {
    return null
  }

  return (
    <span className="promo-card__tag">
      <Icon
        svgComponent={AIGeneratedGradientFilled}
        size={ICON_SIZE}
        className="promo-card__tag-icon"
        notSpaced
        aria-hidden="true"
      />
      <span className="promo-card__tag-text cgt-overline-md">
        {translate('search_page.promo_cards.ai.free_trial')}
      </span>
    </span>
  )
}

export default FreeTrialTag
